import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import useWhiteLabelComponent from '../../hooks/useWhiteLabelComponent';

import translationKeys from '../../translations/keys';

import {
    FooterContainer,
    LinksRow,
    FooterLink,
    MarketingContainer,
    MarketingHeaderContainer,
} from './Footer.styles';
import Button from '../button';
import Heading from '../heading';
import { VL_BLACK } from '../../utils/colours';

/** Shown at bottom of every page that uses header/footer layout. */
const Footer = ({
    termsLinkText,
    privacyLinkText,
    termsLink,
    privacyLink,
    t,
    ...props
}) => {
    const { isVideoloft } = useWhiteLabelComponent();

    const [marketingMessage, setMarketingMessage] = useState(1);
    const [isVisible, setIsVisible] = useState(true);
    useEffect(() => {
        const interval = setInterval(() => {
            setIsVisible(false); // Start fade out
        
            setTimeout(() => {
                setMarketingMessage(prev => prev === 8 ? 1 : prev + 1);
                setIsVisible(true); // Fade back in
            }, 800);
        }, 8000); // Updates every 8 seconds
    
        return () => clearInterval(interval); // Cleanup
      }, []);

    // const logo = fullScreenLayoutLogo ?? appLayoutLogo ?? appLayoutLogoSmall;
    return (
        <FooterContainer $isVideoloft={isVideoloft} {...props}>
           {isVideoloft && <MarketingContainer>
                 <MarketingHeaderContainer $isVisible={isVisible}>
                    <Heading variant={5} redDot style={{margin: 0, color: VL_BLACK()}}>{t(translationKeys.sharing.marketing[`M${marketingMessage}`])}</Heading>
                </MarketingHeaderContainer>
                <Button variant="outline" style={{flexShrink: 0}} link="https://videoloft.com/product/features/" target="_blank">
                    {t(translationKeys.common.LEARN_MORE)}
                </Button>
            </MarketingContainer>}
            <LinksRow style={{margin: '10px 0'}}>
                <FooterLink href={termsLink}>{termsLinkText}</FooterLink>
                <FooterLink href={privacyLink}>{privacyLinkText}</FooterLink>
            </LinksRow>
        </FooterContainer>
    );
};

Footer.propTypes = {
    /** Text used for 'Terms of Service' link. */
    termsLinkText: PropTypes.string.isRequired,
    /** Text used for privacy policy link. */
    privacyLinkText: PropTypes.string.isRequired,
};

export default withTranslation()(Footer);
